import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import CheckBox from '@components/inputs/checkBox'
import Avatar from '@components/avatar'

import { WindowContext } from '@components/windowContextProvider'

import { Text, Container, CheckBoxContainer } from './styles'

const BeneficiaryCheckBox = ({
  name, imageBase64, isChecked, onChange,
}) => {
  const { clientWidth } = useContext(WindowContext)
  return (
    <Container>
      <CheckBoxContainer>
        <CheckBox checked={isChecked} onChange={() => onChange(!isChecked)} />
      </CheckBoxContainer>
      {clientWidth > 950 ? <Avatar name={name} imageBase64={imageBase64} /> : null}
      <Text>{name}</Text>
    </Container>
  )
}

BeneficiaryCheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  imageBase64: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}
BeneficiaryCheckBox.defaultProps = { imageBase64: null, isChecked: false }
export default BeneficiaryCheckBox
